import React, { useState, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Input,
  Row,
  Col,
  message,
  Form,
  DatePicker,
  Typography,
  Modal,
  Select,
} from "antd";
import IntlMessages from "../util/IntlMessages";
import ds from "../Services/DataServices";
import moment from "moment";
import { BEHAVIOUR_TYPE } from "../Services/DataServices";
import {
  notAllowMsgCheck,
  StringIsNullOrEmpty,
  isEmptyObject,
  getRandomInt,
  getDecryptID,
} from "../appRedux/actions";
import { DeleteOutlined } from "@ant-design/icons";
import { loadProductBatchesRowData } from "../appRedux/actions";

const { Title } = Typography;
const dateFormat = "YYYY-MM-DD";
const confirm = Modal.confirm;

const ProductBatches = (props) => {
  
  const isAddMode = true;
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const getReduxProductBatchesRowData = useSelector(
    ({ Products }) => Products.getProductBatchesRowData
  );
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  );

  const handleFocus = (event) => event.target.select();

  const handleChangeVariantBatchesInput = async (
    event,
    Key,
    batchID,
    batchInputType,
    index
  ) => {
    let inputValue = event;
    let productVariantBatchesData = [...getReduxProductBatchesRowData];
    let variantBatchesCurrentIndexData = getReduxProductBatchesRowData[index];

    if (
      variantBatchesCurrentIndexData &&
      variantBatchesCurrentIndexData.length > 0 &&
      inputValue != "" &&
      inputValue != undefined &&
      inputValue != null &&
      batchInputType &&
      batchInputType != ""
    ) {
      let currentVariantBatchRow = variantBatchesCurrentIndexData.filter(
        (e) => e.Key == Key
      )[0];
      if (!isEmptyObject(currentVariantBatchRow)) {
        if (batchInputType == "BatchCode") {
          currentVariantBatchRow.BatchCode = inputValue.target.value;
        }
        if (batchInputType == "BatchQuantity") {
          currentVariantBatchRow.BatchQuantity = inputValue.target.value;
        }
        if (batchInputType == "BatchExpiryDate") {
          currentVariantBatchRow.BatchExpiryDate =
            moment(inputValue).format(dateFormat);
        }
        if (batchInputType == "BatchManufacturingDate") {
          currentVariantBatchRow.BatchManufacturingDate =
            moment(inputValue).format(dateFormat);
        }
        if (batchInputType == "OutletID") {
          currentVariantBatchRow.OutletID = inputValue;
        }
        productVariantBatchesData[index] = variantBatchesCurrentIndexData;
        dispatch(loadProductBatchesRowData(productVariantBatchesData));
      }
    }
  };
  const AddDeleteVariantProductBatchesOption = (
    event,
    isRemove,
    id,
    batchID,
    index,
    productID
  ) => {
    let variantBatchesData = [...getReduxProductBatchesRowData];
    let VariantBatchesCurrentIndexData = getReduxProductBatchesRowData[index];
    
    if (VariantBatchesCurrentIndexData != undefined) {
      if (isRemove) {
        if (batchID != 0) {
          onClickBatchDelete(batchID);
          variantBatchesData[index] = VariantBatchesCurrentIndexData.filter(
            (obj) => obj.BatchID != batchID
          );
          dispatch(loadProductBatchesRowData(variantBatchesData));
        } else {
          variantBatchesData[index] = VariantBatchesCurrentIndexData.filter(
            (obj) => obj.Key != id
          );
          dispatch(loadProductBatchesRowData(variantBatchesData));
        }
      } else {
        variantBatchesData[index] = VariantBatchesCurrentIndexData.concat({
          Key: VariantBatchesCurrentIndexData
            ? VariantBatchesCurrentIndexData.slice(-1)[0].Key + 1
            : 0,
          BatchID: "",
          BatchCode: "",
          BatchQuantity: "",
          BatchExpiryDate: moment().format(dateFormat),
          RecordID: "0",
          IsRemove: false,
          IsUnique: true,
          ProductID: productID,
          RandomKey: getRandomInt(100000000),
          OutletID: "",
          BatchManufacturingDate: moment(),
        });
        dispatch(loadProductBatchesRowData(variantBatchesData));
      }
    } else {
      variantBatchesData[index] = [
        {
          Key: 0,
          BatchID: "",
          BatchCode: "",
          BatchQuantity: "",
          BatchExpiryDate: moment().format(dateFormat),
          RecordID: "0",
          IsRemove: false,
          IsUnique: true,
          ProductID: productID,
          RandomKey: getRandomInt(100000000),
          OutletID: "",
          BatchManufacturingDate: moment(),
        },
      ];
      dispatch(loadProductBatchesRowData(variantBatchesData));
    }
  };
  const onClickBatchDelete = (batchID) => {
    let body = {
      BatchID: `${batchID}&&_da1a-77cb-4563-bc20-d1b957c65b25`,
      BehaviorName: 2,
    };
    postDeleteProductBatch(body);
  };
  async function postDeleteProductBatch(body) {
    //setLoader(true);
    await ds
      .postDeleteProductBatchByID(body, BEHAVIOUR_TYPE.POST)
      .then((res) => {
        if (res.data.data.isDeleted) {
          //setLoader(false);
          message.success(res.data.data.message);

          // getProductListing(pagination);
        } else {
          message.error(res.data.data.message);
        }
      })
      .catch((error) => {
        notAllowMsgCheck(error);
        message.error("Something went wrong...");
      });
  }
  const validateNumber = (_, value, type) => {
    if (value == undefined || !/^\d+$/.test(value) || value<=0) {
      return Promise.reject("Please enter a valid Batch Quantity,always greater than zero.");
    }
    return Promise.resolve();
  };
  const validateExpiryDate = (_, value, row, variantName) => {
    const manufacturingDate = moment(row.BatchManufacturingDate).startOf("day");
    const expiryDate = moment(value).startOf("day");
    if (!value || expiryDate.isSameOrAfter(manufacturingDate)) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(
        ` ${
          !StringIsNullOrEmpty(variantName)
            ? `Variant Name : ${variantName},`
            : ""
        } Batch Code : ${
          row.BatchCode
        } -- Expiry date must be the same day or after the manufacturing date`
      )
    );
  };
  return (
    <div class="child-variant-div">
      {props.record.batchLimit <= 30 ? (
        <div>
          <h2 className="custom-font-weight-500 custom-font-color-black">
            <IntlMessages id="products.main.add.batchdetails" />
          </h2>
          <Row>
            <Col md={24}>
              <Row>
                <Col md={4} sm={8}>
                  <Title level={5}>
                    <IntlMessages id="products.main.add.batchcode" />
                  </Title>
                </Col>

                <Col md={4} sm={8}>
                  <Title level={5}>
                    <IntlMessages id="products.main.add.batchquantity" />
                  </Title>
                </Col>
                <Col md={4} sm={8}>
                  <Title level={5}>
                    <IntlMessages id="products.main.add.outlet1" />
                  </Title>
                </Col>
                <Col md={4} sm={8}>
                  <Title level={5}>
                    <IntlMessages id="products.main.add.batchmanufacturingdate" />
                  </Title>
                </Col>
                <Col md={4} sm={8}>
                  <Title level={5}>
                    <IntlMessages id="products.main.add.batchexpirydate" />
                  </Title>
                </Col>
              </Row>
              {getReduxProductBatchesRowData[props.index] &&
                getReduxProductBatchesRowData[props.index]
                  .filter((e) => e.IsRemove != true)
                  .map((obj) => {
                    return (
                      <Row Key={obj.Key} className="dk-mg-lft-0">
                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchCodeVariant" + obj.Key + obj.RandomKey]:
                                obj.BatchCode,
                            }}
                            name={props.name}
                            onFinish={props.onFinish}
                            form={props.form}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom"
                              name={
                                "BatchCodeVariant" + obj.Key + obj.RandomKey
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseenterbatchcode" />
                                  ),
                                },
                              ]}
                              onFocus={handleFocus}
                              onBlur={(event) =>
                                handleChangeVariantBatchesInput(
                                  event,
                                  obj.Key,
                                  obj.BatchID,
                                  "BatchCode",
                                  props.index
                                )
                              }
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <Input placeholder="Enter a Batch Code" />
                              ) : (
                                obj.BatchCode
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchQuantityVariant" +
                              obj.Key +
                              obj.RandomKey]: obj.BatchQuantity,
                            }}
                            onFinish={props.onFinish}
                            name={props.name}
                            form={props.form}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom"
                              name={
                                "BatchQuantityVariant" + obj.Key + obj.RandomKey
                              }
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseenterbatchquantity" />
                                  ),
                                },
                                { validator: validateNumber },
                              ]}
                              onFocus={handleFocus}
                              onBlur={(event) =>
                                handleChangeVariantBatchesInput(
                                  event,
                                  obj.Key,
                                  obj.BatchID,
                                  "BatchQuantity",
                                  props.index
                                )
                              }
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <Input placeholder="Enter a Batch Quantity" />
                              ) : (
                                obj.BatchQuantity
                              )}
                            </Form.Item>
                          </Form>
                        </Col>
                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["OutletIDVariant" + obj.Key + obj.RandomKey]:
                                !StringIsNullOrEmpty(obj.OutletID)
                                  ? obj.OutletID
                                  : obj.OutletID, ///here we add moment object
                            }}
                            onFinish={props.onFinish}
                            name={props.name}
                            form={props.form}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right"
                              name={"OutletIDVariant" + obj.Key + obj.RandomKey}
                              label=""
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id="products.main.add.pleaseselectoutlet" />
                                  ),
                                },
                              ]}
                            >
                              <Select
                                placeholder={
                                  <IntlMessages id="products.main.add.selectoutlet" />
                                }
                                showSearch
                                optionFilterProp="children"
                                onChange={(event) =>
                                  handleChangeVariantBatchesInput(
                                    event,
                                    obj.Key,
                                    obj.BatchID,
                                    "OutletID",
                                    props.index
                                  )
                                }
                                disabled={
                                  isAddMode || obj.BatchID == 0 ? false : true
                                }
                              >
                                {getReduxStoreOutlets &&
                                  getReduxStoreOutlets.map((e, index) => {
                                    return (
                                      <option
                                        key={obj.Key}
                                        value={getDecryptID(e.id).toString()}
                                      >
                                        {e.outlet}
                                      </option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchManufacturingDateVariant" +
                              obj.Key +
                              obj.RandomKey]: !StringIsNullOrEmpty(
                                obj.BatchManufacturingDate
                              )
                                ? moment(obj.BatchManufacturingDate)
                                : moment(), ///here we add moment object
                            }}
                            onFinish={props.onFinish}
                            name={props.name}
                            form={props.form}
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right "
                              name={
                                "BatchManufacturingDateVariant" +
                                obj.Key +
                                obj.RandomKey
                              }
                              label=""
                              style={{ width: "100%" }}
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <DatePicker
                                  onChange={(event) =>
                                    handleChangeVariantBatchesInput(
                                      event,
                                      obj.Key,
                                      obj.BatchID,
                                      "BatchManufacturingDate",
                                      props.index
                                    )
                                  }
                                  format={dateFormat}
                                />
                              ) : !StringIsNullOrEmpty(
                                  obj.BatchManufacturingDate
                                ) ? (
                                moment(obj.BatchManufacturingDate).format(
                                  dateFormat
                                )
                              ) : (
                                moment()
                              )}
                            </Form.Item>
                          </Form>
                        </Col>
                        <Col md={4} sm={24}>
                          <Form
                            initialValues={{
                              ["BatchExpiryDateVariant" +
                              obj.Key +
                              obj.RandomKey]: !StringIsNullOrEmpty(
                                obj.BatchExpiryDate
                              )
                                ? moment(obj.BatchExpiryDate)
                                : moment(), ///here we add moment object
                            }}
                            onFinish={props.onFinish}
                            name={props.name}
                            form={props.form}

                            // validateTrigger="onBlur"
                          >
                            <Form.Item
                              className="ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment"
                              name={
                                "BatchExpiryDateVariant" +
                                obj.Key +
                                obj.RandomKey
                              }
                              label=""
                              style={{ width: "100%" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select the expiry date",
                                },
                                {
                                  validator: (_, value) =>
                                    validateExpiryDate(_, value, obj),
                                },
                              ]}
                            >
                              {isAddMode || obj.BatchID == 0 ? (
                                <DatePicker
                                  onChange={(event) =>
                                    handleChangeVariantBatchesInput(
                                      event,
                                      obj.Key,
                                      obj.BatchID,
                                      "BatchExpiryDate",
                                      props.index
                                    )
                                  }
                                  format={dateFormat}
                                />
                              ) : !StringIsNullOrEmpty(obj.BatchExpiryDate) ? (
                                moment(obj.BatchExpiryDate).format(dateFormat)
                              ) : (
                                moment()
                              )}
                            </Form.Item>
                          </Form>
                        </Col>

                        <Col md={4}>
                          <Button
                            type="primary"
                            onClick={(event) =>
                              confirm({
                                title: "Permanent Delete ?",
                                content: `"Are you sure you want to delete"`,
                                okText: 'Yes',
      cancelText: 'No',
      okButtonProps:{className: 'dk-btn-add close-reg-btn'},
      cancelButtonProps: {className: "dk-btn-cancel close-reg-btn"},
                                onOk() {
                                  AddDeleteVariantProductBatchesOption(
                                    event,
                                    true,
                                    obj.Key,
                                    obj.BatchID,
                                    props.index,
                                    props.record.key
                                  );
                                },
                                onCancel() {
                                  //console.log('Cancel');
                                },
                              })
                            }
                            icon={<DeleteOutlined />}
                            size={"middle"}
                            danger={true}
                          />
                        </Col>
                      </Row>
                    );
                  })}

              {getReduxProductBatchesRowData[props.index] ? (
                getReduxProductBatchesRowData[props.index].length <
                props.record.batchLimit ? (
                  <Button
                    className="custom-searchbtn"
                    type="primary"
                    icon={<i className="icon icon-add-circle dk-pd-10" />}
                    // onClick={(event) =>
                    //   AddDeleteVariantSKUCodeTypeOption(
                    //     event,
                    //     false,
                    //     0,
                    //     0,
                    //     props.index
                    //   )
                    // }
                    onClick={(event) => {
                      AddDeleteVariantProductBatchesOption(
                        event,
                        false,
                        0,
                        0,
                        props.index,
                        props.record.key
                      );
                    }}
                    size="large"
                  >
                    <IntlMessages id="products.main.add.addanotherbatchcode" />
                  </Button>
                ) : (
                  <></>
                )
              ) : props.record.batchLimit <= 30 ? (
                <Button
                  className="custom-searchbtn"
                  type="primary"
                  icon={<i className="icon icon-add-circle dk-pd-10" />}
                  // onClick={(event) =>
                  //   AddDeleteVariantSKUCodeTypeOption(
                  //     event,
                  //     false,
                  //     0,
                  //     0,
                  //     props.index
                  //   )
                  // }
                  onClick={(event) =>
                    AddDeleteVariantProductBatchesOption(
                      event,
                      false,
                      0,
                      0,
                      props.index,
                      props.record.key
                    )
                  }
                  size="large"
                >
                  <IntlMessages id="products.main.add.addanotherbatchcode" />
                </Button>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </div>
      ) : (
        <>
          <p>
            <IntlMessages id="stock.edit.onlyallow30batches" />
          </p>
        </>
      )}
    </div>
  );
};

export default ProductBatches;
